
// ステージ作成
var stage = new createjs.Stage("js-particle");

// パーティクルシステム
var particleSys = new particlejs.ParticleSystem();

// 初期のパーティクル発生量
var emitFrequency = null;

// パーティクルの描画をステージに登録
stage.addChild( particleSys.container );

// パーティクルパラメーター読み出し
$.ajax( 'js/parameter.json?2', {
	dataType: 'json'
})
.done( function( data ){
	// 初期発生量を記録
	emitFrequency = data.emitFrequency;
	// jsonパラメータ
	particleSys.importFromJson( data );
	// フレームレート
	createjs.Ticker.framerate = 30;
	// requestAnimationFrameで定期描画
	createjs.Ticker.timingMode = createjs.Ticker.RAF;
	// 定期的に呼ばれる関数
	createjs.Ticker.addEventListener("tick", handleTick );
	// サイズ調整
	handleResize();
	$(window).on('resize', $.throttle( 200, handleResize ));
});

/*******************
* ウィンドウリサイズ
*/
function handleResize(){
	var w =  window.innerWidth;
	var h = window.innerHeight;
	// var ratio = window.devicePixelRatio;
	var ratio = 1;

	// ステージサイズ調整
	stage.canvas.width = w * ratio;
	stage.canvas.height = h * ratio;
	// パーティクル発生位置の調整
	particleSys.startXVariance = w * 1.5 * ratio;
	particleSys.startY = h * 1.2 * ratio;
	// モバイルではパーティクル発生量を抑える
	if( $.isMobile ){
		particleSys.emitFrequency = emitFrequency * .5;
	}else{
		particleSys.emitFrequency = emitFrequency;
	}
}

/*******************
* requestAnimationFrame で呼ばれる関数
*/
function handleTick(){
	// パーティクルの発生・更新
	particleSys.update();
	// 描画更新
	stage.update();
}